import gql from 'graphql-tag'
import {
  fetchBase,
  makeBody,
  basicResponseHandler,
  rejectResponseAbove,
} from '../'

import { organizationAttrsFragment } from '../organizations'

const AuthAPI = {
  getTokens({ apiEndpoint }, { email, password, organizationId }) {
    return fetch(`${apiEndpoint}/auth/token`, {
      ...fetchBase(),
      method: 'POST',
      body: makeBody('authToken', {
        email,
        password,
        organizationId,
      }),
    }).then(basicResponseHandler)
  },

  renewTokens({ apiEndpoint }, { renewalToken }) {
    return fetch(`${apiEndpoint}/auth/renew`, {
      ...fetchBase(),
      method: 'POST',
      body: makeBody('authToken', {
        renewalToken,
      }),
    }).then(basicResponseHandler)
  },

  verify({ apiEndpoint }, { apiToken }) {
    return fetch(`${apiEndpoint}/auth/verify`, {
      ...fetchBase({ apiToken }),
      method: 'POST',
    }).then(basicResponseHandler)
  },

  signOut({ apiEndpoint, apiToken }) {
    return fetch(`${apiEndpoint}/auth/sign-out`, {
      ...fetchBase({ apiToken }),
    }).then(rejectResponseAbove(400))
  },

  requestResetPassword({ apiEndpoint }, { email, organizationId }) {
    return fetch(`${apiEndpoint}/auth/request-reset-password`, {
      ...fetchBase(),
      method: 'POST',
      body: makeBody('requestResetPasswords', {
        email,
        organizationId,
      }),
    }).then(rejectResponseAbove(400))
  },

  resetPassword({ apiEndpoint }, { password, resetPasswordToken }) {
    return fetch(`${apiEndpoint}/auth/reset-password`, {
      ...fetchBase(),
      method: 'POST',
      body: makeBody('resetPasswords', {
        password,
        resetPasswordToken,
      }),
    }).then(rejectResponseAbove(400))
  },

  revokeOrganizationSSO: gql`
    mutation RevokeOrganizationSSO {
      revokeOrganizationSSO {
        ...organizationAttrs
      }
    }
    ${organizationAttrsFragment}
  `,

  sendReconciliationSSOEmail: gql`
    mutation SendReconciliationSSOEmail($userId: ID!) {
      sendReconciliationSSOEmail(userId: $userId) {
        __typename
        id
      }
    }
  `,
}

export default AuthAPI
